// extracted by css-extract-rspack-plugin
export default {"cls1":"AttachmentOverlay-cls1_AvZ","cls2":"AttachmentOverlay-cls2_1Lf AttachmentOverlay-cls1_AvZ"};